import React, { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import api from '../../helpers/api';
import { Field } from 'formik';
import FieldContainer from './Misc/FieldContainer';

const SkillsSearchable = props => {
  // const {options} = props
  const [options, setOptions] = useState(props.options);
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (query) {
      const timeId = setTimeout(() => {
        getSkills(query);
      }, 500);
      return () => clearTimeout(timeId);
    }
  }, [query]);
  const handleChange = (newValue, actionMeta) => {
    console.group('Value Changed');
    console.log(newValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();

    // newValue?.forEach();
    if (newValue)
      newValue.forEach(element => {
        if (element.__isNew__)
          api.post('https://api.warshatna.com/api/skills', { skill: query });
      });

    if (actionMeta.action === 'create-option' && newValue.__isNew__)
      // api.post('/skills', { skill: query });
      console.log('yes');
  };

  const getSkills = async value => {
    setLoading(true);
    try {
      const { data } = await api.get(`/skills/${value}`);

      setOptions(data);
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  const getOptions = () => {
    if (!options) return [];
    return options?.map(data => {
      const newOption = {};
      newOption.value = data._id;
      newOption.label = data.skill;
      return newOption;
    });
  };

  console.log(getOptions(),options, 'options');
  return (
    <Field name={props.name}>
      {({ form, field, meta }) => {
        console.log(field.value, 'values');

        return (
          <div className='form-group'>
            {/* <label className="col-lg-3 col-form-label" htmlFor={fieldName}> */}
            <label htmlFor={props.name}>{props.label} :</label>
            <FieldContainer errorMessage={meta.error}>
              <CreatableSelect
                isMulti
                onChange={(newValue, actionMeta) => {
                  // newValue?.forEach();

                  if (newValue) {
                    // form.setFieldValue(field.name, newValue);
                    const values = newValue;

                    values.forEach(async (element, index) => {
                      if (element.__isNew__) {
                        const result = await api.post('/skills', {
                          skill: query
                        });

                        values[index] = {
                          value: result.data._id,
                          label: result.data.skill
                        };
                      }
                    });
                    form.setFieldValue(field.name, values);
                  }
                  if (newValue === null) form.setFieldValue(field.name, []);
                }}
                onInputChange={change => {
                  setQuery(change);
                }}
                // getOptionLabel={option => option.name}
                // getOptionValue={option => option._id}
                options={getOptions()}
                defaultValue={getOptions()}
                formatCreateLabel={text => `اضاف ${text}`}
                isLoading={loading}
              />
            </FieldContainer>
          </div>
        );
      }}
    </Field>
  );
};

export default SkillsSearchable;
